import { ADMIN_OR_ABOVE } from "@excel-center/shared";
import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ProtectedRoute } from "@/src/auth/components/protected-route";
import { GROUPS_ROUTES } from "@/src/groups/constants/groups-routes.constants";

const GroupsListPage = lazy(() => import("@/src/groups/pages/groups-list.page"));

export const groupsAuthedRoutes: RouteObject[] = [
	{
		path: GROUPS_ROUTES.groups,
		element: (
			<ProtectedRoute requiredRole={[...ADMIN_OR_ABOVE]}>
				<GroupsListPage />
			</ProtectedRoute>
		),
	},
];
